module.exports = __webpack_public_path__ + "static/media/image33.3adbbc6b.jpg";